import { memo, useMemo } from "react";
import { SlateEditor } from "@components/mainInterface/chat/slate/SlateEditor";
import { SlateValue } from "@components/mainInterface/chat/slate/slateTypes";
import { deserializeSlateValue } from "@components/mainInterface/chat/slate/slateHelpers";
import styles from "./CreateTaskDrawer.module.scss";

type SerializedSlateValue = string | null | undefined;

export const DescriptionField = memo<{
    onChange: (value: SlateValue) => void;
    serializedValue: SerializedSlateValue;
}>(
    ({ onChange, serializedValue }) => {
        const slateValue = useMemo(() => {
            if (serializedValue === null || serializedValue === undefined) {
                return undefined;
            }
            try {
                return deserializeSlateValue(serializedValue);
            } catch {
                return undefined;
            }
        }, [serializedValue]);

        return (
            <SlateEditor
                value={slateValue}
                placeholder="Add opening chat..."
                onChange={onChange}
                className={styles.descriptionEditor}
                hideKeyboardShortcut
                displayActions={false}
                placeholderClassName={styles.placeholderClassName}
            />
        );
    },
    (prevProps, nextProps) =>
        prevProps.serializedValue === nextProps.serializedValue &&
        prevProps.onChange === nextProps.onChange,
);
